export default function normaliseIconName(item: string): string {
    return item.replace(/(card_mono_|icon_original_|icon_mono_|card_original_)/, '')
}
